import { responsive } from '@/utils';

import type { ChipsSize, SegmentedChipsRadiusRules } from './chips.types';

const BORDER_RADIUS = responsive.radius.rounded;
export const BORDER_WIDTH = '0.0625rem';

export const outlineWidth = responsive.spacing.xsmall;
export const iconSizeByButtonSize: Record<ChipsSize, string> = {
  xSmall: '1rem',
  small: '1rem',
  medium: '1.5rem',
};

const squareRadiusBySize: Record<ChipsSize, string> = {
  xSmall: responsive.radius.xsmall,
  small: responsive.radius.xsmall,
  medium: responsive.radius.large,
};

export const getSegmentedChipsContainerBorderRadius = (
  size: ChipsSize,
  radiusRules: SegmentedChipsRadiusRules
): string => (radiusRules === 'pill' ? BORDER_RADIUS : squareRadiusBySize[size]);

export const getSegmentedChipsButtonBorderRadius = ({
  size,
  variant,
  radiusRules = 'pill',
}: {
  size: ChipsSize;
  variant?: 'standalone' | 'group';
  radiusRules?: SegmentedChipsRadiusRules;
}): string =>
  variant === 'group' && radiusRules === 'square' ? squareRadiusBySize[size] : BORDER_RADIUS;

/** Loader overlay radius — pill uses spacing token; square matches the pill container. */
export const getSegmentedChipsLoaderBorderRadius = (
  size: ChipsSize,
  radiusRules: SegmentedChipsRadiusRules
): string =>
  radiusRules === 'pill'
    ? responsive.spacing.xlarge
    : getSegmentedChipsContainerBorderRadius(size, radiusRules);
